import {Authority} from '@/oauth/Authority';
import {date} from "quasar";

export class User {
    public id?: number;
    public username = '';
    public password = '';
    public secondpassword = '';
    public code = '';
    public authorities: Authority[] = [];
    // public code = '';
    public receiver = '';
    public name = '';
    public avatarUrl = '';
    public createDate?: Date;
    public lastLoginDate?: Date;
    public sex = '';
    public gongHao = '';
    public sidemodel: string | null =''
    public version: string | null ='';

    // public collectionCompany= '';

    public static of(user: any) {
        return Object.assign(new User(), user);
    }

    public hasRole(...role: string[]) {
        return role.every(value => {
            if (!value.startsWith('ROLE_')) {
                value = 'ROLE_' + value;
            }
            const b = this.hasAuthority(value);
            return b;
        });

    }

    public static getColmuns(): QTableColumn[] {
        return [
            {name: 'name', field: 'name', label: '名字'},
            {name: 'username', field: 'username', label: '用户名'},
            {name: 'createDate', field: ('createDate'), label: '创建时间'},
            {name: 'lastLoginDate', field: 'lastLoginDate', label: '最后登录时间'},
        ]
    }

    public hasAnyRole(...role: string[]) {
        return role.some(value => {
            if (!value.startsWith('ROLE_')) {
                value = 'ROLE_' + value;
            }
            return this.hasAuthority(value);
        });
    }

    public hasPermission(...permission: string[]) {
        return permission.every(value => {
            if (!value.startsWith('PERMISSION_')) {
                value = 'PERMISSION_' + value;
            }
            return this.hasAuthority(value);
        });
    }

    public hasAnyPermission(...permission: string[]) {
        return permission.some(value => {
            if (!value.startsWith('PERMISSION_')) {
                value = 'PERMISSION_' + value;
            }
            return this.hasAuthority(value);
        });
    }

    public hasAuthority(authority: string): boolean {
        try {
            return this.authorities.some((v) => {
                return v.authority.toUpperCase() === authority.toUpperCase();
            });
        } catch (e) {
            return false;
        }
    }

    public addAuthority(...authority: Authority[]) {
        if (!Array.isArray(this.authorities)) {
            this.authorities = [];
        }
        this.authorities.push(...authority);
    }
}
